<template>
  <v-container class="pa-0">
    <v-menu v-model="menu.flags.show" :position-x="menu.flags.x" :position-y="menu.flags.y" absolute offset-y z-index="212" :close-on-content-click="false">
      <v-list dense>
        <v-list-tile v-for="(item, index) in menu.flags.items" :key="`flag-${index}`">
          <v-list-tile-action>
            <v-checkbox v-model="menu.datum.UpdatedFlags" color="success" :value="item.FlagCode" :label="item.FlagText" />
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </v-menu>

    <v-menu v-model="menu.media.show" :position-x="menu.media.x" :position-y="menu.media.y" absolute offset-y z-index="212">
      <v-list dense>
        <v-list-tile v-for="(item, index) in menu.media.items" :key="`media-${index}`" @click="setItemMedia(item)">
          <v-list-tile-title :class="{ 'success--text': isSelectedMedia(item), 'font-weight-bold': isPreviousMedia(item) }">{{ item }}
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>

    <v-menu v-model="menu.datums.show" :position-x="menu.datums.x" :position-y="menu.datums.y" absolute offset-y z-index="212">
      <v-list dense>
        <v-list-tile v-for="(item, index) in menu.datums.items" :key="`datum-${index}`" @click="setItemDatum(item.DatumText)">
          <v-list-tile-title :class="{ 'success--text': isSelectedDatum(item.DatumText), 'font-weight-bold': isPreviousDatum(item.DatumText) }">
            {{ item.DatumText || 'None' }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>

    <v-menu v-model="menu.sampletypes.show" :position-x="menu.sampletypes.x" :position-y="menu.sampletypes.y" absolute offset-y z-index="212">
      <v-list dense>
        <v-list-tile v-for="(item, index) in menu.sampletypes.items" :key="`sampletype-${index}`" @click="setItemSampleType(item)">
          <v-list-tile-title :class="{ 'success--text': isSelectedSampleType(item), 'font-weight-bold': isPreviousSampleType(item) }">{{ item }}
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>

    <v-dialog v-model="menu.depthheight.show" persistent max-width="300">
      <v-card>
        <v-card-text>
          <v-subheader>Start Value</v-subheader>
          <v-text-field label="Enter start value in m" v-model="depthHeightStartValue" :rules="[rules.depthHeightRules]"></v-text-field>
          <v-subheader>End Value</v-subheader>
          <v-text-field label="Enter end value in m" v-model="depthHeightEndValue" :rules="[rules.depthHeightRules]">
          </v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn small color="success" :disabled="saveButtonDisabled" @click="saveDepthHeight()">
            <v-icon class="mr-1">done</v-icon>{{ $t('Button.Save') }}
          </v-btn>
          <v-btn small color="secondary" outline @click="closeDialog()">{{ $t('Button.Close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog content-class="tabular-dialog" v-model="dialog" persistent>
      <v-card>
        <v-layout style="flex-direction: column;">
          <v-flex style="flex: 0 0 64px;">
            <v-toolbar dark color="primary">
              <v-toolbar-title>
                <template v-if="timeRange && timeRange[0]">Tabular view - {{ formatDate(timeRange[0], dateFormat) }} to
                  {{ formatDate(timeRange[1], dateFormat) }}</template>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click="close()" dark>
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
          </v-flex>
          <v-alert v-if="hasMismatchedUnitGroup.length" :value="true" class="ma-0" color="warning lighten-2" icon="warning" outline>
            <div class="primary--text">
              <div>
                The following <span v-if="hasMismatchedUnitGroup.length == 1">analyte</span>
                <span v-else>analytes</span> in the query results contain data with units inconsistent with analyte unit group:
              </div>
              <div>
                <ul>
                  <li :key="index" v-for="(i, index) in hasMismatchedUnitGroup">{{ i }}</li>
                </ul>
              </div>
            </div>
          </v-alert>
          <v-flex style="flex: 1 1 0%; min-width: 0; min-height: 0;">
            <v-layout style="height: 100%;">
              <v-flex md2 xs2 style="flex: 1 1 0%; background-color: #f7f7f7; min-height: 0; min-width: 200px; display: flex; flex-direction: column;">
                <v-flex class="px-2" style="flex: 0 0 57px; background-color: white; border-bottom: 1px solid #e5e5e5; min-width: 0;">
                  <v-text-field v-model="search" :loading="isSearching" :disabled="loading || isSaving" append-icon="search" hide-details full-width label="Search analytes" clearable></v-text-field>
                </v-flex>
                <v-flex style="flex; 1 1; min-height: 0;">
                  <v-container style="overflow: auto; height: 100%;">
                    <template v-if="hasMismatchedUnitGroup.length">
                      <v-layout style="margin-bottom:5px">
                        <v-flex>
                          <v-icon color="warning lighten-2">palette</v-icon>
                        </v-flex>
                        <v-flex>Data with mismatched unit are highlighted.</v-flex>
                      </v-layout>
                    </template>
                    <template v-if="hasUpdate">
                      <v-layout style="margin:7px 0 7px 0;">
                        <v-flex><v-icon color="#cad2ff">palette</v-icon></v-flex>
                        <v-flex>Modified data are highlighted.</v-flex>
                      </v-layout>
                    </template>
                    <template v-if="hasInvalidDatumData">
                      <v-layout style="margin:7px 0 7px 0;">
                        <v-flex><v-icon color="#bb1a22b3">palette</v-icon></v-flex>
                        <v-flex>Data with incompleted datum and depth height values are highlighted.</v-flex>
                      </v-layout>
                      
                    </template>
                    <v-divider></v-divider>
                    <template v-if="loading">
                      <v-list style="background-color: transparent">
                        <div class="subheading">Flags</div>
                        <template v-for="index in 2">
                          <v-list-tile :key="index">
                            <v-list-tile-content>
                              <v-list-tile-title class="loading-skeleton-1">
                                {{ index }} -
                                <small>{{ index }}</small>
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </template>
                      </v-list>
                    </template>
                    <template v-else>
                      <v-list style="background-color: transparent">
                        <div class="subheading">Flags</div>
                        <template v-for="(item, i) in selectFlags">
                          <v-list-tile :key="i">
                            <v-list-tile-content style="display: flex;">
                              <v-list-tile-title class="flags">
                                {{ item.FlagCode }} -
                                <small>
                                  {{ item.Description }}
                                  <span v-if="!item.ShowValues && !isShowAll">(excluded)</span>
                                </small>
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </template>
                      </v-list>
                    </template>
                    <v-divider></v-divider>
                    <template>
                      <v-list style="background-color: transparent" subheader>
                        <div class="subheading mt-2">Settings</div>
                        <v-switch color="success" :disabled="loading || isSaving" hide-details v-model="isShowAll" label="Show values hidden by flags"></v-switch>
                        <v-switch color="success" :disabled="loading || isSaving" hide-details v-model="showAllHeaders" label="Show all columns"></v-switch>
                        <v-switch color="success" :disabled="loading || isSaving" hide-details v-model="requestData.includeAnalyteName" label="Show Envirodata Analyte Name"></v-switch>
                        <v-switch color="success" v-show="false" :disabled="loading || isSaving" hide-details v-model="slowMode" label="Slow mode (large data)"></v-switch>
                      </v-list>
                    </template>
                    <transition name="fade">
                      <v-list style="background-color: transparent" v-if="!loading && isEditing">
                        <v-divider />
                        <div class="subheading mt-2">Bulk Edit</div>
                        <v-select :items="selectFlags" :disabled="isSaving" label="Add flags" multiple flat style="border: 1px solid #ddd" clearable v-model="addFlagsData" item-text="FlagText" item-value="FlagCode" solo hide-details color="success">
                          <template v-slot:selection="{ item, index }">
                            <span v-if="index === 0">{{ addFlagsData.join(', ') }}</span>
                          </template>
                        </v-select>
                        <v-select class="mt-1" :disabled="isSaving" :items="menu.media.items" label="Set Media" flat style="border: 1px solid #ddd" clearable v-model="setMediaData" solo hide-details color="success" />

                        <v-select class="mt-1" :disabled="isSaving" :items="menu.sampletypes.items" label="Set Sample Type" flat style="border: 1px solid #ddd" clearable v-model="setSampleTypeData" solo hide-details color="success" />

                        <v-select class="mt-1" :disabled="isSaving" :items="selectDatum" label="Set Datum" flat style="border: 1px solid #ddd" clearable v-model="setDatumData" item-text="DatumText" item-value="DatumText" solo hide-details color="success" />

                        <v-text-field class="mt-1" solo flat style="border: 1px solid #ddd" hide-details clearable :disabled="isSaving" label="Set start value in m" v-model="setStartValue">
                        </v-text-field>

                        <v-text-field class="mt-1" solo flat style="border: 1px solid #ddd" hide-details clearable :disabled="isSaving" label="Set end value in m" v-model="setEndValue">
                        </v-text-field>

                        <v-btn class="mx-0" :loading="isAddBulk" :disabled="isSaving || (addFlagsData.length == 0 && setMediaData == null && setSampleTypeData == null && setDatumData == null && (setStartValue == null || setEndValue == null)) || !(isPartialSelection || selectAll)" color="success" @click="addBulk()">
                          <v-icon class="mr-1">add</v-icon>
                          {{ $t('Button.Add') }}
                        </v-btn>
                      </v-list>
                    </transition>
                  </v-container>
                </v-flex>
              </v-flex>

              <v-flex md10 xs10 style="min-width: 0; display: flex; flex-direction: column;">
                <v-flex style="flex: 0 0 57px;">
                  <v-layout>
                    <v-card-text ref="virtualCollectionHeader" style="overflow-x: hidden;" class="card_text pa-0 rowHeader">
                      <table class="v-table v-datatable--select-all theme--light">
                        <thead style="width: 100%;">
                          <tr class="text-xs-left" style="width: 100%; display: flex; border-bottom: none">
                            <template v-for="(header, index) in headers">
                              <template>
                                <th v-if="header.text == 'Select'" v-show="!header.hide" :key="`th-${index}`" class="column active sortable pa-0 d-flex align-center max-width" :style="getCellStyle(header)">
                                  <transition name="fade">
                                    <v-checkbox v-if="isEditing" color="primary" :disabled="loading || isSaving" :indeterminate="isPartialSelection" v-model="selectAll" class="th-checkbox py-0 px-2 ma-0" hide-details />
                                  </transition>
                                </th>
                                <SlicedHeader v-else v-show="!header.hide" :headerStyle="getCellStyle(header)" :key="`th-${index}`" ref="slicedHeaders" :header="header" @slice="onSlice()" :sortable="!!header.sorter" :active="isActiveSort(header)" :descending="sort.descending" @sort="onSort(header)" :data="items" :disabled="loading || isSaving" :slowMode="slowMode" />
                              </template>
                            </template>
                            <th v-if="!loading" style="width: 0px; min-width: 0px;"></th>
                          </tr>
                        </thead>
                      </table>
                    </v-card-text>
                  </v-layout>
                </v-flex>
                <v-flex class="virtual-collection-flex" style="flex: 1 0 0%; min-height: 0; min-width: 0; overflow: hidden;">
                  <v-card-text class="card_text pa-0" style="height: 100%; display: block;">
                    <table style="display: block;" ref="dataTable" @click="showItemMenu($event)">
                      <tbody style="display: block;" ref="virtualContainer">
                        <template v-if="loading">
                          <div class="cell-container" style="height: 48px;" v-for="index in skeletonDataItems" :key="`row-${index}`">
                            <v-layout class="row">
                              <template v-for="(header, index) in headers">
                                <v-flex v-show="!header.hide" :key="`cell-${index}`" :id="`cell${header.value}`" :class="`cell cell${header.value}`" :style="getCellStyle(header)">
                                  <div v-if="header.text == 'Select'">
                                    <transition name="fade">
                                      <v-checkbox color="success" v-if="isEditing" disabled class="cell-checkbox" hide-details />
                                    </transition>
                                  </div>
                                  <div class="loading-skeleton-1" v-else>{{ skeletonData[index] }}</div>
                                </v-flex>
                              </template>
                            </v-layout>
                          </div>
                        </template>
                        <template v-else>
                          <VirtualCollection ref="virtualCollection" :cellSizeAndPositionGetter="cellSizeAndPositionGetter" :collection="collectionItems" :height="dom.containerHeight" :width="dom.containerWidth">
                            <template slot="cell" slot-scope="props">
                              <v-layout :id="`row-${props.data.Id}`" class="row" :class="[{'row-selected': selected[props.data.Id].value}, `item-background-${ decideBackgroundColor(props.data)}`]">
                                <template v-for="(header, index) in headers">
                                  <v-flex v-show="!header.hide" :key="`cell-${index}`" :id="`cell${header.value}-${props.data.Id}`" :class="{[`cell cell${header.value}`]: true }" :style="getCellStyle(header)">
                                    <template v-if="header.text == 'Select'">
                                      <transition name="fade">
                                        <v-checkbox color="success" v-if="isEditing" class="cell-checkbox" :disabled="isSaving" v-model="selected[props.data.Id].value" @change="trackCheckbox(props.data.Id)" hide-details />
                                      </transition>
                                    </template>
                                    <span v-else-if="header.value == 'CocCode'" v-html="generateLinkHtml(props.data[header.value], props.data)" />
                                    <span v-else-if="header.value == 'DateTime'" v-html="header.format(props.data.DateTime)" />
                                    <template v-else-if="header.value == 'DepthHeight'">
                                      <v-btn v-if="isEditing" :disabled="isSaving" small block flat class="dropdown-btn">
                                        <span :class="{ 'success--text': props.data.UpdatedDepthHeight != props.data.DepthHeight}" v-html="props.data.UpdatedDepthHeight" />
                                        <v-icon small>edit</v-icon>
                                      </v-btn>
                                      <template v-else v-html="props.data.UpdatedDepthHeight" />
                                    </template>
                                    <template v-else-if="header.value == 'DatumText'">
                                      <v-btn v-if="isEditing" :disabled="isSaving" small block flat class="dropdown-btn">
                                        <span :class="{ 'success--text': props.data.UpdatedDatumText != props.data.DatumText}">{{ props.data.UpdatedDatumText }}</span>
                                        <v-icon>arrow_drop_down</v-icon>
                                      </v-btn>
                                      <template v-else>{{ props.data.UpdatedDatumText}}</template>
                                    </template>
                                    <template v-else-if="header.value == 'MediaType'">
                                      <v-btn v-if="isEditing" :disabled="isSaving" small block flat class="dropdown-btn">
                                        <span :class="{ 'success--text': isMediaTypeUpdate(props.data)}">{{ props.data.UpdatedMediaType }}</span>
                                        <v-icon>arrow_drop_down</v-icon>
                                      </v-btn>
                                      <template v-else>{{ props.data.UpdatedMediaType }}</template>
                                    </template>
                                    <template v-else-if="header.value == 'SampleType'">
                                      <v-btn v-if="isEditing" :disabled="isSaving" small block flat class="dropdown-btn">
                                        <span :class="{ 'success--text': props.data.UpdatedSampleType != props.data.SampleType }">{{ props.data.UpdatedSampleType }}</span>
                                        <v-icon>arrow_drop_down</v-icon>
                                      </v-btn>
                                      <template v-else>{{ props.data.UpdatedSampleType }}</template>
                                    </template>
                                    <template v-else-if="header.value == 'Flags'">
                                      <v-btn v-if="isEditing" :disabled="isSaving" small block flat class="dropdown-btn">
                                        <span v-for="(flag, flagIndex) in props.data.UpdatedFlags" :key="`updatedFlag-${index}-${flagIndex}`">
                                          <span :class="{ 'success--text': !props.data.Flags.includes(flag)}">{{ flag }}
                                            <template v-if="flagIndex < props.data.UpdatedFlags.length - 1">
                                              , &nbsp;
                                            </template>
                                          </span>
                                        </span>
                                        <v-icon>arrow_drop_down</v-icon>
                                      </v-btn>
                                      <template v-else>{{ props.data.Flags.join(', ')}}</template>
                                    </template>
                                    <template v-else-if="header.value == 'Logs'">
                                      <v-btn small @click="showLogs(props.data.Id)">
                                        <v-icon class="mr-1">receipt_long</v-icon>
                                        <span class="text-none">Logs&nbsp;</span>
                                      </v-btn>
                                    </template>
                                    <span v-else v-html="props.data[header.value]" />
                                  </v-flex>
                                </template>
                              </v-layout>
                              <hr />
                            </template>
                          </VirtualCollection>
                        </template>
                      </tbody>
                    </table>
                  </v-card-text>
                </v-flex>
                <v-flex style="flex: 0 0 52px; background-color: #f7f7f7;">
                  <v-card-actions>
                    <v-spacer></v-spacer>

                    <template v-if="isEditing">
                      <v-btn :disabled="!hasUpdate || hasInvalidDatumData" color="success" :loading="isSaving" @click="saveUpdatedResult()">
                        <v-icon class="mr-1">done</v-icon>
                        {{ $t('Button.Save') }}
                      </v-btn>
                      <v-btn :disabled="isSaving" @click="setEditing(false)">
                        {{ $t('Button.Cancel') }}</v-btn>
                    </template>
                    <template v-else>
                      <v-btn v-if="isTenantAdmin" :disabled="loading || isSaving" @click="setEditing(true)">
                        <v-icon color="warning" class="mr-1">edit</v-icon>
                        {{ $t('Button.Edit') }}
                      </v-btn>
                      <v-btn color="primary" @click="close()">{{ $t('Button.Close') }}</v-btn>
                    </template>
                  </v-card-actions>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <v-dialog v-model="logsDialog" persistent max-width="800">
      <v-card style="background-color: #f7f7f7">
        <v-card-title class="headline" style="justify-content: center;">
          Correction Logs
        </v-card-title>
        <v-progress-linear v-if="!CorrectionLogs.length && !Loaded" indeterminate></v-progress-linear>
        <v-card-text v-if="CorrectionLogs.length && Loaded">
          <v-expansion-panel>
            <v-expansion-panel-content v-for="(item, i) in CorrectionLogs" :key="i">
              <template v-slot:header>
                <span>
                  <b>Process Instance Number: </b>{{ item.ProcessInstanceId }}
                  <br>
                  <b>Triggered By: </b>{{ item.TriggeredBy }}
                  <br>
                  <b>Date Time: </b>{{ formatDate(item.DateTime, 'MMMM DD, YYYY @ HH:mm') }}
                  <br>
                  <b>Notes: </b>{{ item.Notes }}
                </span>
              </template>
              <v-layout row wrap style="padding: 12px 24px;">
                <span>
                  <span><b>Changes: </b></span><br>
                  <v-chip small v-for="(i, index) in item.Operations" :key="index">
                    {{ i.PropertyName }} :&nbsp;
                    <span style="color:#fb8c00">{{ i.OriginalValue }}</span>&nbsp;→&nbsp;
                    <span style="color:#4caf50">{{ i.ResultValue }}</span>
                  </v-chip>
                </span>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-card-text>
        <v-card-text v-if="!CorrectionLogs.length && Loaded">
          <v-alert :value="showLogsError" type="error" outline>System fails to fetch logs for the lab result.</v-alert>
          <v-alert :value="!showLogsError" type="warning" outline>No Correction Logs.</v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn outline color="secondary" @click="closeLogs()">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ConfirmationDialog ref="confirmationDialog" :title="confirmationDialog.title" :text="confirmationDialog.text" :confirmText="confirmationDialog.confirmText" :cancelText="confirmationDialog.cancelText" :color="confirmationDialog.color" @submit="confirmationDialog.action" />
  </v-container>
</template>

<script>
  import {
    getScrollbarSize,
  } from '@/helpers/dom'
  import {
    debounce,
    defaultDebounceDelay,
  } from '@/helpers/performance'
  import {
    sliceData,
  } from '@/helpers/slicer'
  import {
    customSearcher,
    getObjectValues,
  } from '@/helpers/search'

  import {
    defaultTableSorter,
    objectSorter,
    stringSorter,
    datetimeSorter,
    numberSorter,
  } from '@/helpers/sorting'

  import {
    arraysEqual,
    sortCaseInsensitive,
  } from '@/helpers/arrays'

  import axios from 'axios'
  import { getWidthOfText } from '@/helpers/strings'
  import MomentUtil from '@/components/mixins/MomentUtil'
  import {
    newDateStringNoTimezone,
  } from '@/components/mixins/MomentUtil'

  import {
    formatDepthHeightValues,
    generateDatumText,
  } from '@/helpers/depthHeight'

  import {
    ShowAllValue,
    ShowValueOnly,
  } from '@/helpers/dataFilter'

  import {
    createNamespacedHelpers,
  } from 'vuex'
  const imports = createNamespacedHelpers('imports')
  const authenticate = createNamespacedHelpers('authenticate')
  const flags = createNamespacedHelpers('flags')
  const stations = createNamespacedHelpers('stations')
  const datum = createNamespacedHelpers('datum')

  const closeCancelChangesDialog = {
    title: 'Close Tabular view?',
    text: 'Your changes were not saved.',
    confirmText: 'Discard & Close',
    cancelText: 'Keep editing',
    color: 'warning',
  }

  const cancelChangesDialog = {
    title: 'Cancel editing?',
    text: 'Your changes will be lost.',
    confirmText: 'Discard changes',
    cancelText: 'Keep editing',
    color: 'warning',
  }

  const COL_PADDING = 60

  function determineWidth(datum, header) {
    let a = header.width || (getWidthOfText(header.text, '18px') + COL_PADDING)

    if (!datum[header.value]) {
      return a
    }

    let b = (header.format ? String(header.format(datum[header.value])) : String(datum[header.value]))
    b = getWidthOfText(b) + COL_PADDING

    let result = a > b ? a : b
    return result
  }

  export default {
    mixins: [MomentUtil],
    props: {
      requestData: Object,
    },
    data() {
      return {
        confirmationDialog: {
          title: '',
          text: '',
          confirmText: '',
          cancelText: '',
          color: '',
          action: () => {},
        },
        loading: true,
        slowMode: true,
        isSearching: false,
        isEditing: false,
        isSaving: false,
        isAddBulk: false,

        search: '',
        menu: {
          datum: {},
          flags: {
            show: false,
            x: 0,
            y: 0,
            items: [],
          },
          media: {
            show: false,
            x: 0,
            y: 0,
            items: [
              'Ground Water',
              'QAQC',
              'Surface Water',
              'Unknown',
              'Process Water',
              'Dustfall',
              'Drinking Water',
              'ML-ARD',
              'Soil',
              'Plant Tissue',
              'Water',
            ],
          },
          datums: {
            show: false,
            x: 0,
            y: 0,
            items: [],
          },
          sampletypes: {
            show: false,
            x: 0,
            y: 0,
            items: [
              'Sample',
              'Duplicate',
              'Field Blank',
              'Trip Blank',
            ],
          },
          depthheight: {
            show: false,
          },
        },
        dateFormat: 'MMMM DD, YYYY @ HH:mm',
        dialog: true,

        skeletonData: [
          'checkbox',
          'fake datetime',
          'some analyte',
          'value',
          'unit',
          'detection limit',
          'sample type',
          'coccode',
          'media',
          'flags',
        ],
        skeletonDataItems: 3,

        isShowAll: false,
        showAllHeaders: true,
        annotationFlags: [],

        items: [],
        selected: {},
        selectedCount: 0,
        collectionItems: [],
        filteredItems: [],
        customSearchItems: [],

        cocLookup: [],

        addFlagsData: [],
        setMediaData: null,
        setSampleTypeData: null,
        setDatumData: null,
        setStartValue: null,
        setEndValue: null,

        sort: {
          active: null,
          descending: false,
        },

        dom: {
          containerHeight: 0,
          containerWidth: 0,
          maxWidths: [],
          totalWidth: 0,
          scrollbarSize: {},
        },

        depthHeightStartValue: null,
        depthHeightEndValue: null,

        rules: {
          depthHeightRules: value => {
            if (value < 0) return 'Value can not be negative'
            if (isNaN(value)) return 'Value must be a number/decimal'
            if ((this.depthHeightStartValue && this.depthHeightEndValue) && (this.depthHeightStartFloat > this
                .depthHeightEndFloat)) return 'Start value must be less than end value'
            return true
          },
          // required: value => !!value || 'Required', 
        },
        logsDialog: false,
        hasMismatchedUnitGroup: [],
      }
    },
    computed: {
      ...imports.mapGetters(['importlist']),
      ...authenticate.mapGetters(['isTenantAdmin', 'currentUserGroup']),
      ...flags.mapGetters(['flags']),
      ...stations.mapGetters(['mediaTypeList', 'MediaTypeDisplayToActualDictionary', 'CorrectionLogs', 'Loaded', 'showLogsError']),
      ...datum.mapGetters(['datumList']),
      allHeaders() {
        return {
          select: {
            order: 0,
            text: 'Select',
            align: 'left',
            width: 50,
          },
          datetime: {
            order: 1,
            text: 'DateTime',
            align: 'left',
            value: 'DateTime',
            width: 120,
            format: date => this.formatDate(date, this.dateFormat),
            sorter: objectSorter('DateTime', datetimeSorter),
          },
          displayanalyte: {
            order: 2,
            text: 'Display Name',
            value: 'DisplayAnalyte',
            align: 'left',
            width: 150,
            sorter: objectSorter('DisplayAnalyte', stringSorter),
          },
          analyte: {
            order: 3,
            text: 'EnviroData Analyte Name',
            value: 'Analyte',
            align: 'left',
            width: 150,
            sorter: objectSorter('Analyte', stringSorter),
            hide: !this.requestData.includeAnalyteName,
          },
          value: {
            order: 4,
            text: 'Value',
            value: 'Value',
            align: 'right',
            width: 130,
            sorter: objectSorter('Value', numberSorter),
          },
          unit: {
            order: 5,
            text: 'Unit',
            value: 'Unit',
            align: 'left',
            width: 120,
            sorter: objectSorter('Unit', stringSorter),
          },
          detectionlimit: {
            order: 6,
            text: 'Detection Limit',
            value: 'DL',
            align: 'right',
            width: 150,
            sorter: objectSorter('DL', numberSorter),
          },
          sampletype: {
            order: 7,
            text: 'Sample Type',
            value: 'SampleType',
            align: 'left',
            width: 180,
            sorter: objectSorter('SampleType', stringSorter),
            hide: !this.showAllHeaders,
          },
          coccode: {
            order: 8,
            text: 'COC Code',
            value: 'CocCode',
            align: 'left',
            width: 120,
            sorter: objectSorter('CoCCode', stringSorter),
            hide: !this.showAllHeaders,
          },
          depthheight: {
            order: 9,
            text: 'Depth/Height (m)',
            value: 'DepthHeight',
            align: 'right',
            width: 140,
            sorter: objectSorter('DepthHight', stringSorter),
          },
          datumtext: {
            order: 10,
            text: 'Depth/Height Datum',
            value: 'DatumText',
            align: 'right',
            width: 160,
            sorter: objectSorter('DatumText', stringSorter),
          },
          media: {
            order: 11,
            text: 'Media',
            value: 'MediaType',
            align: 'left',
            width: 100,
            sorter: objectSorter('ActualMediaType', stringSorter),
          },
          flags: {
            order: 12,
            text: 'Flags',
            value: 'Flags',
            align: 'left',
            width: 100,
            slicerValues: this.flags.map(f => f.FlagCode),
            includeNull: true,
          },
          comment: {
            order: 13,
            text: 'Comment',
            value: 'Comment',
            align: 'left',
            width: 100,
            sorter: objectSorter('Comment', stringSorter),
          },
          logs: {
            order: 14,
            text: 'Logs',
            value: 'Logs',
            align: 'center',
            width: 100,
            hide: !this.showAllHeaders,
          },
        }
      },
      headers() {
        let headers = this.allHeaders
        let result = [
          headers.select,
          headers.datetime,
          headers.displayanalyte,
          headers.analyte,
          headers.value,
          headers.unit,
          headers.detectionlimit,
          headers.media,
          headers.flags,
          headers.sampletype,
          headers.coccode,
          headers.depthheight,
          headers.datumtext,
          headers.logs,
          headers.comment
        ]

        const sorter = (hA, hB) => {
          if (hA.order > hB.order) return 1
          if (hA.order < hB.order) return -1
          return 0
        }
        result.sort(sorter)

        return result
      },
      selectAll: {
        get() {
          return this.selectedCount == this.filteredItems.length
        },
        set(value) {
          for (let key in this.selected) {
            this.selected[key].value = false
          }

          for (let item of this.filteredItems) {
            let key = item.Id
            this.selected[key].value = value
            this.selectedCount = value ? this.filteredItems.length : 0
          }
        },
      },
      isPartialSelection() {
        if (
          this.items.some(item => this.selected[item.Id].value && !this.selectAll)
        )
          return true
        return false
      },
      timeRange() {
        if (this.requestData != null) {
          return [this.requestData.startDate, this.requestData.endDate]
        } else {
          return []
        }
      },
      hasUpdate() {
        return this.items.some(
          x =>
          (this.isMediaTypeUpdate(x) ||
            x.SampleType != x.UpdatedSampleType ||
            x.Flags.join() != x.UpdatedFlags.join() ||
            x.DatumText != x.UpdatedDatumText ||
            x.DepthHeight != x.UpdatedDepthHeight) &&
          this.isDepthHeightUpdate(x)
        )
      },
      hasInvalidDatumData() {
        return this.items.some(x => !this.isDepthHeightUpdate(x))
      },
      selectFlags() {
        return this.flags.map(flag => {
          return {
            ...flag,
            FlagText: `${ flag.FlagCode }`,
          }
        })
      },
      selectDatum() {
        let datums = this.datumList.map(datum => {
          return {
            ...datum,
            DatumText: `${ datum.DatumName } (${ datum.DatumType.Name })`,
          }
        })
        datums.push({
          Id: null,
          DatumDescription: '',
          DatumName: '',
          DatumText: '',
        })
        return datums
      },
      debounceTimer() {
        return this.slowMode ? defaultDebounceDelay : 0
      },
      onSearch() {
        return debounce(function executable(value) {
          let items = this.customSearch(this.filteredItems, value)

          if (this.customSorter)
            this.customSearchItems = this.customSorter(items)
          else this.customSearchItems = items

          this.makeCollectionItems()
          this.isSearching = false
        }, this.debounceTimer)
      },
      customSorter() {
        if (this.sort.active) {
          return defaultTableSorter(
            this.headers,
            this.sort.active.value,
            this.sort.descending
          )
        }
      },
      customSearch() {
        return customSearcher(this.itemsMetadata)
      },
      depthHeightStartFloat() {
        if (this.depthHeightStartValue && !isNaN(this.depthHeightStartValue)) {
          return parseFloat(this.depthHeightStartValue)
        }
        return null
      },
      depthHeightEndFloat() {
        if (this.depthHeightEndValue && !isNaN(this.depthHeightEndValue)) {
          return parseFloat(this.depthHeightEndValue)
        }
        return null
      },
      saveButtonDisabled() {
        let haveStart = this.depthHeightStartFloat === +this.depthHeightStartFloat
        let haveEnd = this.depthHeightEndFloat === +this.depthHeightEndFloat
        if (haveStart && haveEnd) {
          return false
        } else if (!haveStart && !haveEnd) {
          return false
        } else {
          return true
        }
      },
    },
    watch: {
      'requestData.includeAnalyteName'() {
        this.updateMaxWidths(this.items)
      },
      showAllHeaders() {
        this.updateMaxWidths(this.items)
      },
      isShowAll() {
        this.generateTabular()
      },
      loading(value) {
        if (value) this.loadSkeletons()
      },
      search(value) {
        this.isSearching = true
        this.onSearch(value)
      },
      selectFlags: {
        immediate: true,
        handler(value) {
          this.menu.flags.items = value
        },
      },
      selectDatum: {
        immediate: true,
        handler(value) {
          this.menu.datums.items = value
        },
      },
      datumList(value) {
        //console.log('datums', value)
        this.menu.datums.items = value.map(x => x.DatumName)
      },
    },
    methods: {
      ...stations.mapActions([
        'getWaterQualityStationDetailByName',
        'getCalendarMark',
        'getCorrectionLogs',
        'clearLogs',
        'fetchTabularData',
      ]),
      isDepthHeightUpdate(data) {
        return ((data.UpdatedDatumText && data.UpdatedDepthHeight) ||
          (!data.UpdatedDatumText && !data.UpdatedDepthHeight))
      },
      onSort(header) {
        if (this.sort.active == header) {
          this.$set(this.sort, 'descending', !this.sort.descending)
        } else {
          this.sort.active = header
          this.$set(this.sort, 'descending', false)
        }

        if (this.customSorter)
          this.customSearchItems = this.customSorter(this.customSearchItems)
        this.makeCollectionItems()
      },
      isActiveSort(header) {
        return this.sort.active == header
      },
      resetData() {
        this.items.forEach(item => {
          this.$set(item, 'UpdatedMediaType', item.ActualMediaType)
          this.$set(item, 'UpdatedSampleType', item.SampleType)
          this.$set(item, 'UpdatedDatumText', item.DatumText)
          this.$set(item, 'UpdatedDepthHeight', item.DepthHeight)
          this.$set(item, 'UpdatedFlags', item.Flags.slice())
        })
      },
      trackCheckbox(key) {
        if (this.selected[key].value) this.selectedCount--
        else this.selectedCount++
      },
      resizeListener() {
        let virtualContainer = this.$refs['virtualContainer']
        if (virtualContainer) {
          this.$set(this.dom, 'containerHeight', virtualContainer.offsetHeight)
          this.$set(this.dom, 'containerWidth', virtualContainer.offsetWidth)
        }
      },
      onSlice() {
        sliceData(this.items, this.$refs.slicedHeaders).then(result => {
          this.filteredItems = result
          this.onSearch(this.search)
        })
      },
      makeItemsMetadata() {
        let result = {}
        this.items.forEach(item => {
          result[item.Id] = getObjectValues(item, 'Analyte')
        })
        this.itemsMetadata = result
      },
      isSelectedMedia(item) {
        let datum = this.menu.datum
        if (!datum) return
        return datum.UpdatedMediaType == item
      },
      isSelectedDatum(item) {
        let datum = this.menu.datum
        if (!datum) return
        return datum.UpdatedDatumText == item
      },
      isPreviousMedia(item) {
        let datum = this.menu.datum
        if (!datum) return
        return datum.ActualMediaType == item
      },
      isPreviousDatum(item) {
        let datum = this.menu.datum
        if (!datum) return
        return datum.DatumText == item
      },
      isSelectedSampleType(item) {
        let datum = this.menu.datum
        if (!datum) return
        return datum.UpdatedSampleType == item
      },
      isPreviousSampleType(item) {
        let datum = this.menu.datum
        if (!datum) return
        return datum.SampleType == item
      },
      setItemMedia(item) {
        this.menu.datum.UpdatedMediaType = item
      },
      setItemSampleType(item) {
        this.menu.datum.UpdatedSampleType = item
      },
      setItemDatum(item) {
        this.menu.datum.UpdatedDatumText = item
      },
      showItemMenu(e) {
        if (!this.isEditing || this.isSaving || !e.target) return

        let itemId = null
        let menuType = null
        let setDepthHeight = false

        let element = e.target
        do {
          if (!element.id) {
            element = element.parentElement
            continue
          }

          let split = element.id.split('-')

          if (split[0] == 'cellFlags') {
            itemId = split[1]
            menuType = this.menu.flags
            break
          }

          if (split[0] == 'cellActualMediaType') {
            itemId = split[1]
            menuType = this.menu.media
            break
          } else {
            element = element.parentElement
          }

          if (split[0] == 'cellSampleType') {
            itemId = split[1]
            menuType = this.menu.sampletypes
            break
          } else {
            element = element.parentElement
          }

          if (split[0] == 'cellDatumText') {
            itemId = split[1]
            menuType = this.menu.datums
            break
          } else {
            element = element.parentElement
          }

          if (split[0] == 'cellDepthHeight') {
            itemId = split[1]
            menuType = this.menu.depthheight
            setDepthHeight = true
            break
          } else {
            element = element.parentElement
          }

        } while (element && !itemId)


        if (itemId == null) return
        if (menuType.show) return

        let datum = this.items.find(item => String(item.Id) == itemId)
        if (datum == null) return

        this.menu.datum = datum
        menuType.x = e.clientX
        menuType.y = e.clientY

        if (setDepthHeight) {
          let start = this.getStartNum(this.menu.datum.DepthHeight)
          let end = this.getEndNum(this.menu.datum.DepthHeight)
          start = isNaN(start) ? null : start
          end = isNaN(end) ? null : end
          this.depthHeightStartValue = start
          this.depthHeightEndValue = end
        }

        menuType.show = true
      },
      makeCollectionItems() {
        let items = this.customSearchItems
        this.collectionItems = items.map(item => {
          item.UpdatedMediaType = item.ActualMediaType
          item.UpdatedFlags = item.Flags
          return {
            data: item,
          }
        })
      },
      cellSizeAndPositionGetter(item, index) {
        let width = this.dom.totalWidth
        let height = 48
        return {
          width: width,
          height: height,
          x: 0,
          y: parseInt(index) * height,
        }
      },
      setEditing(value, ignore) {
        if (!value && this.hasUpdate && !ignore) {
          this.confirmCancelChanges()
          return
        }

        this.isEditing = value
        if (!value) {
          this.selectAll = false
          this.setMediaData = null
          this.setSampleTypeData = null
          this.setDatumData = null
          this.setStartValue = null
          this.setEndValue = null
          this.addFlagsData = []
          this.resetData()
        }
      },
      updateMaxWidths(items) {
        let maxWidths = {}
        let allHeaders = Object.values(this.allHeaders)
        items.forEach(item => {
          allHeaders.forEach(header => {
            let index = header.text
            let thisWidth

            thisWidth = determineWidth(
              item,
              header,
            )

            if (!maxWidths[index] || maxWidths[index] < thisWidth) {
              maxWidths[index] = thisWidth
            }
          })
        })

        this.dom.maxWidths = maxWidths
        // if (!this.showAllHeaders) {
        //   maxWidths['Logs'] = 0
        //   maxWidths['COC Code'] = 0
        //   maxWidths['Sample Type'] = 0
        // }

        // if (!this.requestData.includeAnalyteName) {
        //   maxWidths['EnviroData']
        // }

        let widths = JSON.parse(JSON.stringify(maxWidths))
        Object.values(this.allHeaders).forEach(header => {
          if (header.hide) widths[header.text] = 0
        })

        this.dom.totalWidth = Object.values(widths).reduce(
          (accumulator, currVal) => {
            return accumulator + currVal
          },
          0
        )
      },
      getCellStyle(header) {
        let key = header.text
        let maxWidths = this.dom.maxWidths[key]



        if (header.text == 'Select') return {
          'flex-grow': 0,
          'flex-shrink': 0,
          'flex-basis': '50px',
        }

        let flex
        if (maxWidths) {
          flex = {
            'flex-basis': maxWidths + 'px',
            'flex-grow': 0,
            'flex-shrink': 0,
          }
        } else {
          flex = {
            'flex-basis': 0,
            'flex-grow': 0,
            'flex-shrink': 0,
          }
        }

        let justifyContent
        let align = header.align || 'center'
        switch (header.align) {
        case 'left':
          justifyContent = 'start'
          break
        case 'center':
          justifyContent = 'center'
          break
        case 'right':
          justifyContent = 'end'
          break
        }

        return {
          ...flex,
          'justify-content': justifyContent,
          'text-align': align,
          'padding-left': '8px',
          'padding-right': '8px',
        }
      },
      close(ignore) {
        if (this.isEditing && this.hasUpdate && !ignore) {
          this.confirmCloseCancelChanges()
          return
        }

        this.dialog = false
        this.$emit('close')
      },
      confirmCloseCancelChanges() {
        this.confirmationDialog = closeCancelChangesDialog
        this.confirmationDialog.action = () => this.close(true)
        this.$refs.confirmationDialog.show()
      },
      confirmCancelChanges() {
        this.confirmationDialog = cancelChangesDialog
        this.confirmationDialog.action = () => this.setEditing(false, true)
        this.$refs.confirmationDialog.show()
      },
      async fetchDataFromTabular(requestData) {
        return await this.fetchTabularData(requestData)
          .then(res => {
            let data = []
            res.forEach(x => {
              let unitMismatched = false
              x.Points.forEach(p => {
                let flags = p.Flags.sort(sortCaseInsensitive)
                data.push({
                  Id: p.Id,
                  DisplayAnalyte: x.DisplayName,
                  Analyte: x.AnalyteName,
                  DateTime: p.DateTime,
                  DL: p.DetectionLimit,
                  Value: p.Value,
                  Unit: p.Unit,
                  SampleType: p.SampleType,
                  MediaType: p.MediaType,
                  CocCode: p.CocCode,
                  UpdatedMediaType: p.MediaType,
                  ActualMediaType: p.ActualMediaType,
                  UpdatedSampleType: p.SampleType,
                  Flags: flags,
                  ImportId: p.ImportId,
                  IsUnitGroupMismatched: p.IsUnitGroupMismatched,
                  UpdatedFlags: flags.slice(),
                  DepthHeight: formatDepthHeightValues(p.DepthHeightStartValue, p.DepthHeightEndValue),
                  UpdatedDepthHeight: formatDepthHeightValues(p.DepthHeightStartValue,
                    p.DepthHeightEndValue),
                  DatumText: generateDatumText(p),
                  UpdatedDatumText: generateDatumText(p),
                  Comment: p.Comment
                })
                unitMismatched = unitMismatched || p.IsUnitGroupMismatched
              })
              if (unitMismatched) {
                this.hasMismatchedUnitGroup.push(`${x.DisplayName} with unit group ${x.UnitGroup}`)
              }
            })
            return Object.freeze(data)
          })
      },
      setupRows(items) {
        items.forEach(item => {
          this.$set(this.selected, item.Id, {
            value: false,
            reference: item,
          })
        })
      },
      initializeUI() {
        this.filteredItems = this.items
        this.customSearchItems = this.filteredItems
        this.setupRows(this.items)
        this.makeCollectionItems()
        this.updateMaxWidths(this.items)
        this.makeItemsMetadata()
        this.resizeListener()
        this.$nextTick(() => {
          this.$refs.slicedHeaders.forEach(header => {
            header.update()
          })

          let virtualCollectionHeader = this.$refs.virtualCollectionHeader
          let outer = this.$refs.virtualCollection.$refs.outer
          virtualCollectionHeader.style.setProperty(
            'padding-right',
            `${ this.dom.scrollbarSize.width }px`,
            'important'
          )

          window.addEventListener('resize', this.resizeListener)
          outer.onscroll = function() {
            virtualCollectionHeader.scrollLeft = this.scrollLeft
          }

          this.loading = false
        })
      },
      generateTabular() {
        this.loading = true
        if (this.requestData.datasets == undefined) return

        let requestData = {
          StartDate: newDateStringNoTimezone(this.requestData.startDate),
          EndDate: newDateStringNoTimezone(this.requestData.endDate),
          includeQaQc: this.requestData.includeQaQc,
          StationName: this.requestData.stationName,
          StationId: this.requestData.stationId,
          // WaterQualityStandards: this.requestData.guidelines, // THIS IS NOT CURRENTLY USED
          LocationNames: [this.requestData.stationName],
          WaterQualityDatasets: this.requestData.datasets.map(datum => {
            return {
              Id: datum.Id,
              Analyte: datum.Analyte,
            }
          }),
          Media: this.requestData.media,
          LabResultDisplayMode: this.isShowAll ? ShowAllValue : ShowValueOnly,
        }

        this.fetchDataFromTabular(requestData)
          .then(wqData => {
            this.generateCoCLookup(wqData)
            this.items = wqData
            this.initializeUI()
            this.loading = false
          })
          .catch(error => {
            this.loading = false
            this.$jsnLog().error(error)
            throw error
          })
      },
      generateCoCLookup(data) {
        let lookup = {}
        for (let i = 0; i < data.length; i++) {
          let cocCode = data[i].CocCode
          if (lookup[cocCode]) continue
          lookup[cocCode] = this.importlist.find(i => i.coc_code === cocCode)
        }

        this.cocLookup = Object.freeze(lookup)
      },
      generateLinkHtml(cocCode, point) {
        var importLink = ''
        if (point.ImportId != null) {
          importLink = this.$router.resolve(`/import/${ point.ImportId}`).href
        } else {
          let matchedImport = this.cocLookup[cocCode]
          if (matchedImport == null) {
            return ''
          } else {
            importLink = this.$router.resolve(`/import/${ matchedImport.id }`).href
          }
        }
        let html = `<a href='${ importLink }' target="_blank">${ cocCode }</a>`
        return html
      },
      getDatumId(data) {
        let DatumId
        this.selectDatum.forEach(x => {
          if (x.DatumText == data) {
            DatumId = x.Id
          }
        })
        return DatumId
      },
      getStartNum(data) {
        if (data) {
          let startNum
          if (data === +data) {
            startNum = data
          } else {
            startNum = data.match(/<strong>(\S*)<\/strong> to /)[1]
          }
          return parseFloat(startNum)
        } else
          return null
      },
      getEndNum(data) {
        if (data) {
          let endNum
          if (data === +data) {
            endNum = data
          } else {
            endNum = data.match(/ to <strong>(\S*)<\/strong>/)[1]
          }
          return parseFloat(endNum)
        } else
          return null
      },
      async saveUpdatedResult() {
        this.isSaving = true
        let itemsToUpdate = this.items.filter(
          item =>
          this.isMediaTypeUpdate(item) ||
          item.SampleType != item.UpdatedSampleType ||
          !arraysEqual(item.Flags, item.UpdatedFlags) ||
          item.DatumText != item.UpdatedDatumText ||
          item.DepthHeight != item.UpdatedDepthHeight
        )

        if (itemsToUpdate.length == 0) {
          this.setEditing(false)
          this.isSaving = false
          this.$store.dispatch('app/setSnackbar', {
            text: 'Nothing to save',
            color: 'info',
            icon: 'done',
          })
          return
        }

        var updateData = []
        itemsToUpdate.forEach(item => {
          let key = {
            MediaType: this.isMediaTypeUpdate(item) ? item.UpdatedMediaType : item.ActualMediaType,
            SampleType: item.UpdatedSampleType,
            Flags: item.UpdatedFlags,
            DatumId: this.getDatumId(item.UpdatedDatumText),
            DepthHeightStartValue: this.getStartNum(item.UpdatedDepthHeight),
            DepthHeightEndValue: this.getEndNum(item.UpdatedDepthHeight),
          }
          let group = updateData.find(x => this.updateDataCompare(x.GroupKey, key))
          if (group) {
            group.GroupValue.push(item.Id)
          } else {
            updateData.push({
              GroupKey: key,
              GroupValue: [item.Id],
            })
          }
        })

        try {
          await axios.post('api/DataManagement/AnalyteResultsUpdate', updateData)

          this.items.forEach(item => {
            item.MediaType = item.UpdatedMediaType
            item.ActualMediaType = this.isMediaTypeUpdate(item) ? item.UpdatedMediaType : item.ActualMediaType
            item.SampleType = item.UpdatedSampleType
            item.DatumText = item.UpdatedDatumText
            item.Flags = item.UpdatedFlags.slice()
            item.DepthHeight = item.UpdatedDepthHeight
          })
          this.$refs.slicedHeaders.forEach(header => {
            header.update()
          })

          this.setEditing(true)
          this.isSaving = false
          this.$store.dispatch('app/setSnackbar', {
            text: 'Save successful',
            color: 'success',
            icon: 'done',
          })

          this.setEditing(false)
          this.$emit('refresh')
        } catch (error) {
          this.$store.dispatch('app/setSnackbar', {
            text: error,
            color: 'error',
            icon: 'error',
          })

          this.isSaving = false
        }
      },

      updateDataCompare(groupKey, data) {
        var result = []
        for (let x in groupKey) {
          for (let y in data) {
            if (x == y && typeof(groupKey[x]) == typeof(data[y])) {
              switch (typeof(groupKey[x])) {
              case 'string':
                result.push(groupKey[x] == data[y])
                break
              case 'number':
                result.push(groupKey[x] == data[y])
                break
              case 'object':
                if (groupKey[x] instanceof Array) {
                  result.push(arraysEqual(groupKey[x], data[y]))
                } else {
                  result.push(this.updateDataCompare(groupKey[x], data[y]))
                }
                break
              default:
                break
              }
            }
          }
        }
        return result.every(x => x)
      },

      async addBulk() {
        this.isAddBulk = true
        new Promise(resolve => {
          let items = []
          for (let [, /*id*/ item] of Object.entries(this.selected)) {
            if (item.value) items.push(item.reference)
          }

          items.forEach(item => {
            if (this.addFlagsData) {
              item.UpdatedFlags = Array.from(
                new Set(item.UpdatedFlags.concat(this.addFlagsData))
              )
            }
            if (this.setMediaData) {
              item.UpdatedMediaType = this.setMediaData
            }
            if (this.setSampleTypeData) {
              item.UpdatedSampleType = this.setSampleTypeData
            }
            if (this.setDatumData) {
              item.UpdatedDatumText = this.setDatumData
            }
            if (this.setStartValue && this.setEndValue) {     
              item.UpdatedDepthHeight = formatDepthHeightValues(this.setStartValue, this.setEndValue)
            }
          })
          resolve()
        }).then(() => (this.isAddBulk = false))
      },
      async loadSkeletons() {
        let max = 15
        const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
        const randomNumber = (min, max) => Math.random() * (max - min) + min

        while (this.loading) {
          await sleep(randomNumber(750, 1500))
          this.skeletonDataItems++

          if (this.skeletonDataItems == max) {
            this.skeletonDataItems = 3
          }
        }
      },
      closeDialog() {
        this.menu.depthheight.show = false
        this.depthHeightStartValue = null
        this.depthHeightEndValue = null
      },
      saveDepthHeight() {
        this.menu.datum.UpdatedDepthHeight = formatDepthHeightValues(this.depthHeightStartValue,
          this.depthHeightEndValue)
        this.menu.depthheight.show = false
        this.depthHeightStartValue = null
        this.depthHeightEndValue = null
      },
      isMediaTypeUpdate(data) {
        // if (data.MediaType == data.UpdatedMediaType) {
        //   return false
        // } else if (data.MediaType in this.MediaTypeDisplayToActualDictionary && !this
        //   .MediaTypeDisplayToActualDictionary[data.MediaType].some(x => x == data.UpdatedMediaType)) {
        //   return true
        // } else {
        //   if (data.UpdatedMediaType != data.ActualMediaType) {
        //     return true
        //   } else {
        //     return false
        //   }
        // }
        return data.ActualMediaType != data.UpdatedMediaType
      },
      showLogs(Id) {
        if (Id) {
          this.getCorrectionLogs(Id)
          this.logsDialog = true
        }
      },
      closeLogs() {
        this.logsDialog = false
        this.clearLogs()
      },
      decideBackgroundColor(row) {
        if (row.IsUnitGroupMismatched) {
          return 'unitgroup-mismatch'
        } else if (!this.isDepthHeightUpdate(row)) {
          return 'datum-mismatch'
        } else if ((this.isMediaTypeUpdate(row) || 
                  row.SampleType != row.UpdatedSampleType ||
                  row.Flags.join() != row.UpdatedFlags.join() || 
                  row.DatumText != row.UpdatedDatumText || 
                  row.DepthHeight != row.UpdatedDepthHeight)) {
          return 'data-modified'
        } else {
          return 'normal'
        }
      },
    },
    created() {
      this.loadSkeletons()
      this.generateTabular()
    },
    mounted() {
      const preventDoubleClickSelection = event => {
        if (event.detail > 1) {
          event.preventDefault()
        }
      }

      this.$refs.dataTable.addEventListener(
        'mousedown',
        preventDoubleClickSelection,
        false
      )
      this.dom.scrollbarSize = getScrollbarSize()
      this.menu.media.items = this.mediaTypeList.map(x => x.Name)
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.resizeListener)
    },

  }
</script>

<style>
  .top {
    z-index: 21 !important;
  }

  .cell-autocomplete {
    padding-top: 0px;
    margin-top: 0px;
  }

  .th-checkbox {
    opacity: 1 !important;
    font-size: 24px !important;
  }

  .cell-checkbox {
    justify-content: center!important;
    font-size: 24px !important;
    margin-top: 0px;
    padding-top: 0px;
  }

  .th-checkbox>.v-input__control {
    margin: 0 auto;
    padding-top: 0px;
    padding-left: 3px;
  }

  tbody>.vue-virtual-collection {
    overflow: auto !important;
  }

  .tabular-dialog {
    display: block;
    overflow: hidden;
    max-height: 95% !important;
    min-height: 95% !important;
  }

  .tabular-dialog>.v-card>.layout {
    height: 95vh !important;
  }

  .dropdown-btn {
    min-width: 0 !important;
    padding: 0px !important;
    margin: 0px !important;
    text-align: inherit!important;
  }

  .dropdown-btn>.v-btn__content {
    text-align: inherit!important;
    font-weight: normal !important;
    text-transform: initial !important;
  }
</style>
<style scoped>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }

  .fade-enter,
  .fade-leave-to

  /* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
  }

  .virtual-collection-flex {
    flex-grow: 1;
    border: 1px solid #dddddd;
    border-top: none;
    border-right: none;
  }

  .row {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    height: 100%;
    transition: background 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    will-change: background;
    margin-bottom: -2px;
  }

  .rowHeader {
    border-bottom: 1px solid #e5e5e5;
    border-left: 1px solid #e5e5e5;
  }

  .row-selected {
    background: #f3f3f3;
  }

  .cell-container hr {
    border-color: transparent;
  }

  .cell {
    text-align: center;
    font-weight: 400;
    font-size: 13px;
    display: flex;
    flex-shrink: 0;
    flex-grow: 0;
    position: relative;
    align-items: center;
  }

  table {
    height: 100%;
    width: 100%;
  }

  table tbody {
    width: 100%;
    height: 100%;
  }

  .flags {
    height: auto;
    line-height: inherit;
    white-space: normal;
  }
  .item-background-unitgroup-mismatch {
    background: #ffc24b !important;
  }
  .item-background-datum-mismatch {
    background: #bb1a22b3 !important;
  }
  .item-background-data-modified {
    background: #cad2ff !important;
  }
  .item-background-normal {
     background: white !important;
  }
</style>
